import { getProjectsKey, useCreateProject } from 'api-hooks/projects';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { NavigationProps } from 'types';

import ProjectForm from './component/form';

export type ProjectCreateParams = null;

export default function ProjectCreate(
  props: NavigationProps<NavigationRoutes.ProjectCreate>,
) {
  const { navigate } = useNavigation();

  const { mutateAsync, error } = useCreateProject();
  const permission = useGetCrudPermission('projects');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <ProjectForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getProjectsKey()[0]]);

          if (permission.view) {
            navigate(NavigationRoutes.ProjectView, {
              id: result.data.id,
            });
          }
          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
